export default __webpack_public_path__ + "static/media/image2.53b433e2.png";